import Vue from "vue";
import VueAnalytics from "vue-analytics";
import App from "./App.vue";
import router from "./routes.js";
import { guest } from "./plugins/axios";
import { store } from "./store/store";
import "./client/assets/css/tailwind.css";
import AOS from "aos";
import "aos/dist/aos.css";
// import "../node_modules/vue2-animate/dist/vue2-animate.min.css";
// Vue.config.productionTip = false;

//App l
import Default from "./layouts/Client/Client.vue";
import Dashboard from "./layouts/Dashboard/Dashboard.vue";
import Login from "./layouts/Login/Login.vue";

Vue.component("default-layout", Default);
Vue.component("dashboard-layout", Dashboard);
Vue.component("login-layout", Login);

//TODO
// usunac scroll na mobilkach

// Checking auth
router.beforeEach((to, from, next) => {
  const loggedIn = store.getters.loginState;
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) next({ name: "Login" });
  else next();
});

Vue.use(VueAnalytics, {
  id: "UA-91165330-4",
  router,
});

new Vue({
  router,
  guest,
  store,
  created() {
    AOS.init();
  },
  render: (h) => h(App),
}).$mount("#app");
